//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import windowResizeMixin from '@motionelements/core/src/components/mixins/window-resize.mixin.js';
import { bootstrapApp } from '@/services/app-ai.service';

export default {
  name: 'BaseLayout',
  mixins: [windowResizeMixin],
  components: {
    PageMeta: () => import('@/components/core/ThePageMeta.vue'),
    Blocker: () => import('@motionelements/core/src/components/ui/Blocker.vue'),
    ShinySvgGradient: () => import('@motionelements/core/src/components/product/ShinySvgGradient.vue'),
    FlashNotifications: () => import('@/components/core/notifications/BaseFlashNotifications.vue'),
    ToastNotifications: () => import('@/components/core/notifications/BaseToastNotifications.vue'),
    SignUpModal: () => import('@/components/modals/SignUpModal.vue'),
    UnverifiedModal: () => import('@/components/modals/UnverifiedModal.vue'),
    OptimizeExperienceModal: () => import('@/components/modals/OptimizeExperienceModal.vue'),
    FeedbackModal: () => import('@/components/modals/FeedbackModal.vue'),
  },
  head() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      bodyAttrs: {
        class: ['ui-dark'],
      },
    };
  },
  async fetch() {
    await this.getAiTools({ language: this.$i18n.locale });
  },
  beforeCreate() {
    if (!process.server) {
      bootstrapApp(this);
    }
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
      showBlocker: state => state.blocker.show,
      blockerMessage: state => state.blocker.message,
    }),
    ...mapGetters({
      aiToolsReleased: 'aiTools/aiToolsReleased',
    }),
    pageStyle() {
      if (process.client && process.env.VUE_APP_ENV !== 'production') {
        if (this.$route.query.screenshot_lokalise) {
          return 'white-space: nowrap !important; font-family: Arial, Helvetica, sans-serif !important;';
        }
      }
      return '';
    },
    isBaseMeta() {
      return ![...this.aiToolsReleasedIds, 'index'].includes(this.$route.name.split('___')[0].replaceAll('-', '_'));
    },
    aiToolsReleasedIds() {
      return this.aiToolsReleased.map(({ id }) => id);
    },
  },
  methods: {
    ...mapActions({
      getAiTools: 'aiTools/getAiTools',
    }),
  },
};
